import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStoreService } from '../services/auth-store.service';

export const guestGuard: CanActivateFn = async () => {
  const authStore = inject(AuthStoreService);
  const router = inject(Router);

  await authStore.initialize();

  if (!authStore.isAuthenticated()) {
    return true;
  }

  return router.createUrlTree([authStore.getDefaultAuthenticatedRoute()]);
};
